import { useTranslations } from '@vocab/react';
import {
  Text,
  IconClear,
  Columns,
  Column,
  ButtonIcon,
} from 'braid-design-system';
import type React from 'react';

import type * as Schema from 'src/types/graphql';

import translations from './.vocab';

interface LocationItemProps {
  location: Schema.Location2;
  onRemoveLocation: (location: Schema.Location2) => void;
}

export const LocationItem = ({
  location,
  onRemoveLocation,
}: LocationItemProps) => {
  const { description } = location;
  const { t } = useTranslations(translations);
  const remove = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    onRemoveLocation(location);
  };

  return (
    <Columns space="small">
      <Column>
        <Text maxLines={1}>{description}</Text>
      </Column>
      <Column width="content">
        <ButtonIcon
          id={`removePreferredLocation${location.id}`}
          label={t('Remove location named description', {
            description,
          })}
          variant="transparent"
          icon={<IconClear />}
          onClick={remove}
        />
      </Column>
    </Columns>
  );
};
